export default "__VITE_ASSET__DNpqsDsA__"